/* eslint-disable import/no-unresolved */
import SvgAlignCenter from './align-center.svg?react';
import SvgAlignLeft from './align-left.svg?react';
import SvgAlignRight from './align-right.svg?react';
import SvgApprove from './approve.svg?react';
import SvgBold from './bold.svg?react';
import SvgColorText from './color-text.svg?react';
import SvgDropDown from './drop-down.svg?react';
import SvgFormattingOptions from './formatting-options.svg?react';
import SvgItalic from './italic.svg?react';
import SvgListBulleted from './list-bulleted.svg?react';
import SvgListNumbered from './list-numbered.svg?react';
import SvgQuote from './quote.svg?react';
import SvgRedo from './redo.svg?react';
import SvgStrikethrough from './strikethrough.svg?react';
import SvgUnderlined from './underlined.svg?react';
import SvgUndo from './undo.svg?react';

export const icon = {
  SvgAlignCenter,
  SvgAlignLeft,
  SvgAlignRight,
  SvgApprove,
  SvgBold,
  SvgColorText,
  SvgDropDown,
  SvgFormattingOptions,
  SvgItalic,
  SvgListBulleted,
  SvgListNumbered,
  SvgQuote,
  SvgRedo,
  SvgStrikethrough,
  SvgUnderlined,
  SvgUndo,
};
